import CapsuleText from "./index.vue";

CapsuleText.install = Vue => Vue.component(CapsuleText.componentName, CapsuleText);

export default CapsuleText;
